module.exports = __webpack_public_path__ + "blue-dawn.png?d50ba4d0c54a888faf723d6fe4fccfba";